import React from 'react';
import {RectSkeleton} from 'app/views/components/skeleton';
import styles from './customersListItemSkeleton.module.scss';

export const CustomersListItemSkeleton = () => (
    <div className={styles.item}>
        <RectSkeleton width={144} />
        <RectSkeleton width={200} />
        <div className={styles.row}>
            <RectSkeleton width={120} />
            <RectSkeleton width={80} />
        </div>
    </div>
);
